(function () {
  'use strict';

  if (window.GreenicheTranslationGlossary) return;

  var configElement = document.getElementById('GreenicheTranslationGlossaryConfig');
  if (!configElement) return;

  var config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    console.error('[Greeniche glossary] Invalid configuration.', error);
    return;
  }

  var terms = Array.isArray(config.terms) ? config.terms : [];
  if (!terms.length) return;

  var TERM_SELECTOR = '[data-greeniche-translation-term]';
  var OPEN_TAIL_SELECTOR = '.open-tail-g, .open-tail-g-collection-h1, .open-tail-g-top-h2';
  var IGNORE_SELECTOR = [
    TERM_SELECTOR,
    '[translate="no"]',
    '.notranslate',
    '[data-greeniche-translation-ignore]',
    '[contenteditable="true"]',
    'script', 'style', 'noscript', 'textarea', 'select', 'option',
    'code', 'pre', 'svg', 'math', 'iframe', 'canvas'
  ].join(',');
  var entriesByText = Object.create(null);
  var matchableTexts = [];
  var pendingRoots = [];
  var scanScheduled = false;

  terms.forEach(function (term) {
    if (!isValidTerm(term)) return;
    addEntry(term.source, term, 'source');
    addEntry(term.canonical, term, 'canonical');

    if (Array.isArray(term.corrections)) {
      term.corrections.forEach(function (correction) {
        if (typeof correction === 'string' && correction) {
          addEntry(correction, term, 'correction');
        }
      });
    }
  });

  matchableTexts.sort(function (left, right) {
    return right.length - left.length;
  });

  var termPattern = new RegExp(matchableTexts.map(escapeRegExp).join('|'), 'g');

  function isValidTerm(term) {
    return term && typeof term.source === 'string' && term.source &&
      typeof term.canonical === 'string' && term.canonical &&
      term.source !== term.canonical;
  }

  function addEntry(text, term, kind) {
    if (!entriesByText[text]) matchableTexts.push(text);
    if (!entriesByText[text] || kind === 'source') {
      entriesByText[text] = { term: term, kind: kind };
    }
  }

  function escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function markTerm(element, term, kind) {
    element.setAttribute('data-greeniche-translation-term', kind);
    element.setAttribute('data-greeniche-translation-source', term.source);
    element.setAttribute('data-greeniche-translation-canonical', term.canonical);
  }

  function protectTerm(element) {
    element.setAttribute('translate', 'no');
    element.setAttribute('lang', 'en');
    element.classList.add('notranslate');
  }

  function hasCanonicalPresentation(element, canonical) {
    return element.textContent.replace(/\u0261/g, 'g') === canonical;
  }

  function showOpenTailGreeniche(element) {
    var canonical = element.getAttribute('data-greeniche-translation-canonical');
    if (!canonical || canonical.indexOf('greeniche') === -1 || !hasCanonicalPresentation(element, canonical)) {
      return;
    }

    var firstChild = element.firstElementChild;
    if (firstChild && element.querySelector('.greeniche-glossary-open-tail-g')) return;

    element.textContent = '';
    canonical.split('greeniche').forEach(function (part, index, parts) {
      element.appendChild(document.createTextNode(part));
      if (index < parts.length - 1) {
        var openTailG = document.createElement('span');
        openTailG.className = 'greeniche-glossary-open-tail-g greeniche-glossary-open-tail-g--overlay';
        openTailG.setAttribute('aria-hidden', 'true');
        // Keep a plain "g" in the text (search results, copy); CSS shows the open-tail "\u0261" in its place.
        var plainG = document.createElement('span');
        plainG.className = 'greeniche-glossary-open-tail-g__text';
        plainG.textContent = 'g';
        openTailG.appendChild(plainG);
        element.appendChild(openTailG);
        element.appendChild(document.createTextNode('reeniche'));
      }
    });
    element.setAttribute('aria-label', canonical);
  }

  // Uppercase "ɡ" becomes "Ɡ", which most fonts lack (shown as □). Show the plain "g" there so it renders as "G".
  function fixUppercaseOpenTailG(root) {
    if (!root || !root.querySelectorAll) return;

    var elements = [];
    if (root.nodeType === Node.ELEMENT_NODE && root.matches('.greeniche-glossary-open-tail-g')) {
      elements.push(root);
    }
    Array.prototype.push.apply(elements, root.querySelectorAll('.greeniche-glossary-open-tail-g'));

    elements.forEach(function (openTailG) {
      if (openTailG.classList.contains('greeniche-glossary-open-tail-g--plain')) return;
      if (window.getComputedStyle(openTailG).textTransform !== 'uppercase') return;
      if (openTailG.textContent === 'ɡ') openTailG.textContent = 'g';
      openTailG.classList.add('greeniche-glossary-open-tail-g--plain');
    });
  }

  function createTermElement(text, entry) {
    var element = document.createElement('span');
    markTerm(element, entry.term, entry.kind);

    if (entry.kind === 'source') {
      element.textContent = text;
      element.setAttribute('lang', 'ja');
    } else {
      element.textContent = entry.term.canonical;
      showOpenTailGreeniche(element);
      protectTerm(element);
      if (entry.kind === 'correction') {
        element.setAttribute('data-greeniche-translation-corrected', 'true');
      }
    }

    return element;
  }

  function markSplitSourceContainers(root) {
    var selector = 'a, button, h1, h2, h3, h4, h5, h6, p, li, dt, dd, label';
    var elements = [];

    if (root.nodeType === Node.ELEMENT_NODE && root.matches(selector)) {
      elements.push(root);
    }
    if (root.querySelectorAll) {
      Array.prototype.push.apply(elements, root.querySelectorAll(selector));
    }

    elements.forEach(function (element) {
      if (!element.firstElementChild || element.closest(IGNORE_SELECTOR)) return;

      var source = element.textContent.trim();
      var entry = entriesByText[source];
      if (!entry || entry.kind !== 'source') return;

      var nestedExactMatch = Array.prototype.some.call(element.children, function (child) {
        return child.textContent.trim() === source;
      });
      if (nestedExactMatch) return;

      markTerm(element, entry.term, 'source');
      element.setAttribute('lang', 'ja');
    });
  }

  function protectExistingOpenTailBrands(root) {
    var elements = [];

    if (root.nodeType === Node.ELEMENT_NODE && root.matches(OPEN_TAIL_SELECTOR)) {
      elements.push(root);
    }
    if (root.querySelectorAll) {
      Array.prototype.push.apply(elements, root.querySelectorAll(OPEN_TAIL_SELECTOR));
    }

    elements.forEach(function (openTailG) {
      if (openTailG.closest(TERM_SELECTOR) || openTailG.textContent !== 'g') return;

      var remainder = openTailG.nextSibling;
      if (!remainder || remainder.nodeType !== Node.TEXT_NODE || remainder.nodeValue.indexOf('reeniche') !== 0) {
        return;
      }

      var entry = entriesByText.greeniche;
      var wrapper = document.createElement('span');
      markTerm(wrapper, entry.term, 'canonical');
      var parent = openTailG.parentNode;
      parent.insertBefore(wrapper, openTailG);
      wrapper.textContent = 'greeniche';
      showOpenTailGreeniche(wrapper);
      parent.removeChild(openTailG);
      remainder.nodeValue = remainder.nodeValue.slice('reeniche'.length);
      protectTerm(wrapper);
    });
  }

  function shouldProcess(node) {
    if (!node.nodeValue) return false;

    var containsTerm = matchableTexts.some(function (text) {
      return node.nodeValue.indexOf(text) !== -1;
    });

    return containsTerm && node.parentElement && !node.parentElement.closest(IGNORE_SELECTOR);
  }

  function wrapTextNode(node) {
    var value = node.nodeValue;
    var fragment = document.createDocumentFragment();
    var lastIndex = 0;
    var match;

    termPattern.lastIndex = 0;
    while ((match = termPattern.exec(value)) !== null) {
      if (match.index > lastIndex) {
        fragment.appendChild(document.createTextNode(value.slice(lastIndex, match.index)));
      }
      fragment.appendChild(createTermElement(match[0], entriesByText[match[0]]));
      lastIndex = match.index + match[0].length;
    }

    if (lastIndex === 0) return;
    if (lastIndex < value.length) {
      fragment.appendChild(document.createTextNode(value.slice(lastIndex)));
    }
    node.parentNode.replaceChild(fragment, node);
  }

  function scan(root) {
    if (!root || !document.body) return;

    if (root.nodeType === Node.TEXT_NODE) {
      var parent = root.parentElement;
      if (shouldProcess(root)) wrapTextNode(root);
      fixUppercaseOpenTailG(parent);
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) return;
    if (root.nodeType === Node.ELEMENT_NODE && root.matches(IGNORE_SELECTOR)) return;

    markSplitSourceContainers(root);
    protectExistingOpenTailBrands(root);

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return shouldProcess(node) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var nodes = [];
    var currentNode;
    while ((currentNode = walker.nextNode())) nodes.push(currentNode);
    nodes.forEach(wrapTextNode);
    fixUppercaseOpenTailG(root);
  }

  function findTermElement(node) {
    var element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
    if (!element) return null;
    return element.matches(TERM_SELECTOR) ? element : element.closest(TERM_SELECTOR);
  }

  function correctTranslatedTerm(element) {
    if (!element) return;

    var kind = element.getAttribute('data-greeniche-translation-term');
    var source = element.getAttribute('data-greeniche-translation-source');
    var canonical = element.getAttribute('data-greeniche-translation-canonical');

    if (kind === 'source' && element.textContent.trim() === source) {
      element.setAttribute('lang', 'ja');
      element.removeAttribute('translate');
      element.classList.remove('notranslate');
      element.removeAttribute('data-greeniche-translation-corrected');
      element.removeAttribute('aria-label');
      return;
    }

    if (kind !== 'source' && hasCanonicalPresentation(element, canonical)) return;

    if (!hasCanonicalPresentation(element, canonical)) {
      element.textContent = canonical;
    }
    showOpenTailGreeniche(element);
    fixUppercaseOpenTailG(element);
    protectTerm(element);
    element.setAttribute('data-greeniche-translation-corrected', 'true');
  }

  function queueScan(root) {
    pendingRoots.push(root);
    if (scanScheduled) return;
    scanScheduled = true;

    window.requestAnimationFrame(function () {
      var roots = pendingRoots.slice();
      pendingRoots.length = 0;
      scanScheduled = false;
      roots.forEach(scan);
    });
  }

  function start() {
    scan(document.body);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        correctTranslatedTerm(findTermElement(mutation.target));

        if (mutation.type === 'characterData') {
          queueScan(mutation.target);
        }

        if (mutation.type === 'childList') {
          Array.prototype.forEach.call(mutation.addedNodes, function (node) {
            correctTranslatedTerm(findTermElement(node));
            queueScan(node);
          });
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  window.GreenicheTranslationGlossary = { scan: scan, terms: terms };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}());
